<template lang="pug">
p
  strong NOTE: 
  em(v-html="field.value")
</template>

<script>
export default {
  name: 'Note',
  props: {
    field: Object,
  },
};
</script>

<style lang="scss" scoped>
p {
  font-size: 14px;
  margin: 0 0 1em;
  padding: 0.125rem 0 0.125rem;
  strong {
    color: $red;
  }
}
</style>
